<script>
import Layout from '@layouts/guest.vue'
import { authMethods, authComputed } from '@state/helpers'
import organizationInfoForm from '@/src/guest/components/organization-info-form.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Organization Info Setup` }],
  },
  components: { Layout, organizationInfoForm },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      submitError: '',
      token: null,
      tokenValid: false,
      verifyingToken: true,
      organizationData: null,
    }
  },
  computed: {
    ...authComputed,
    currentRouteName() {
      return this.$router.currentRoute.path
    },
  },
  mounted() {
    // Get token from route params and verify it
    this.token = this.$route.params.token
    if (this.token) {
      this.verifyOrganizationToken({ token: this.token })
        .then((response) => {
          if (response.error) {
            this.submitError = response.error
            this.tokenValid = false
          } else {
            this.tokenValid = true
            // Store the organization data to pass to the form
            this.organizationData = response.organization
          }
        })
        .finally(() => {
          this.verifyingToken = false
        })
    } else {
      this.submitError = 'Invalid setup link'
      this.verifyingToken = false
    }
  },
  methods: {
    ...authMethods,
    postSubmitInfo(params) {
      this.submitError = ''
      return this.organizationSetupInfo({
        token: this.token,
        newPassword: params.newPassword,
        confirmPassword: params.confirmPassword,
        nonprofitName: params.nonprofitName,
        profilePageName: params.profilePageName,
        mainWebsite: params.mainWebsite,
        volunteerWebsite: params.volunteerWebsite,
        missionStatement: params.missionStatement,
        causeId: params.causeId,
        city: params.city,
        state: params.state,
        zip: params.zip,
      }).then((response) => {
        // Check for error responses (422 validation errors or other errors)
        if (response.error || response.errors || response.success === false) {
          // Handle validation errors from backend
          this.submitError =
            response.message || response.error || 'An error occurred'
        } else {
          // Move to next step
          this.$router.push({
            name: 'organization-setup-social',
            params: { token: this.token },
          })
        }
      })
    },
    clearSubmitErrors() {
      this.submitError = ''
    },
  },
}
</script>

<template>
  <Layout style="height: fit-content" class="mt-20 mb-20">
    <div v-if="verifyingToken" class="text-center">
      <p>Verifying your setup link...</p>
    </div>
    <div v-else-if="!tokenValid" class="text-center">
      <h2 class="text-red-600">Invalid or Expired Link</h2>
      <p>{{
        submitError ||
        'This setup link is invalid or has expired. Please contact support.'
      }}</p>
    </div>
    <div v-else>
      <h1 class="home-headline1">Let's start sharing kyndfulness</h1>
      <h2 class="home-headline2"
        >Finish Setting Up Your Organization's Profile</h2
      >
      <organizationInfoForm
        :organization-data="organizationData"
        :submit-error="submitError"
        @post-submit="postSubmitInfo"
        @clear-submit-errors="clearSubmitErrors"
      >
      </organizationInfoForm>
    </div>
  </Layout>
</template>
